import { LanguageItem } from "@app/shared/types/language.type";
const ENGLISH_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "en-ca",
    label: $localize`:English label text|English text label@@EnglishLabelText:English (Canada)`,
}
const FRENCH_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "fr-ca",
    label: $localize`:French label Text |French text label@@FrenchLabelText:French (Canada)`,
}
const ITALIAN_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "it-it",
    label: $localize`:Italian label Text |Italian text label@@ItalianLabelText:Italian`,
}
const SPANISH_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "es-es",
    label: $localize`:Spanish label Text |Spanish text label@@SpanishLabelText:Spanish`,
}
const BELGIAN_FRENCH_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "fr-be",
    label: $localize`:Belgian label Text |Belgian text label@@BelgianFrenchLabelText:Belgian French`,
}
const BRAZILIAN_PORTUGUESE_LANGUAGE_LOCALIZED: LanguageItem = {
    code: "pt-br",
    label: $localize`:Brazilian portuguese label Text |Brazilian portuguese text label@@BrazilianPortugueseLabelText:Brazilian Portuguese`,
}
export const LANGUAGES_LOCALIZED = [
    ENGLISH_LANGUAGE_LOCALIZED, 
    FRENCH_LANGUAGE_LOCALIZED,
    ITALIAN_LANGUAGE_LOCALIZED,
    SPANISH_LANGUAGE_LOCALIZED,
    BELGIAN_FRENCH_LANGUAGE_LOCALIZED,
    BRAZILIAN_PORTUGUESE_LANGUAGE_LOCALIZED
]
